// this concats all the types together for cases where they don't need to be separate
const visit_list = require('./types/visit')
const payment_list = require('./types/payment')
const download_list = require('./types/download')
const contact_list = require('./types/contact')
const call_list = require('./types/call')
const capture_list = require('./types/capture')
const schedule_list = require('./types/schedule')
const grandfathered_list = require('./types/grandfathered')

module.exports = [].concat(
    visit_list,
    payment_list,
    download_list,
    contact_list,
    call_list,
    capture_list,
    schedule_list,
    grandfathered_list
)
